var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 104V144",
    stroke: "rgb(165, 1, 1)",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.152 39.9847L26.1762 191.977C24.7684 194.409 24.0261 197.169 24.0237 199.979C24.0214 202.789 24.7592 205.55 26.1629 207.985C27.5666 210.419 29.5867 212.441 32.0199 213.847C34.4532 215.252 37.2137 215.992 40.0238 215.992H215.976C218.786 215.992 221.547 215.252 223.98 213.847C226.413 212.441 228.433 210.419 229.837 207.985C231.241 205.55 231.979 202.789 231.976 199.979C231.974 197.169 231.232 194.409 229.824 191.977L141.848 39.9847C140.442 37.5566 138.423 35.5406 135.992 34.1392C133.562 32.7377 130.806 32 128 32C125.194 32 122.438 32.7377 120.008 34.1392C117.577 35.5406 115.558 37.5566 114.152 39.9847Z",
    stroke: "rgb(165, 1, 1)",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 190C133.523 190 138 185.523 138 180C138 174.477 133.523 170 128 170C122.477 170 118 174.477 118 180C118 185.523 122.477 190 128 190Z",
    fill: "rgb(165, 1, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.54778740609ceb57e78fb9c4f58b2d26.svg";
export { ForwardRef as ReactComponent };